import { useRuntimeConfig } from '#app';

export const useEnvVar = (env_var: string) => {
    const config = useRuntimeConfig();
    // Read straight from the URL: VueUse's useUrlSearchParams writes the query back with a
    // relative `history.replaceState` (even with `write: false`), which throws under the
    // `?assetOrigin=` <base>. See docs/handover/seller-tools-embed.md.
    const params = import.meta.client ? new URLSearchParams(window.location.search) : null;

    const canOverride = !config.public.IS_PROD || config.public.FORCE_ENV_OVERRIDE;

    if (canOverride && params?.has(env_var)) {
        return params.get(env_var);
    }

    return config.public[env_var];
};
